/**
 * Enum de status de assinatura, com os valores esperados pelo backend (tabela no banco).
 */
export enum TypeSubscriptionStatus {
    PENDING = 'PENDING',   // pendente
    ACTIVE = 'ACTIVE',     // ativo
    CANCELED = 'CANCELED', // cancelado
    INACTIVE = 'INACTIVE', // inativo
}

/**
 * Enum em português para exibir em grids e selects no frontend.
 */
export enum TypeSubscriptionStatusBr {
    PENDING = 'Pendente',
    ACTIVE = 'Ativo',
    CANCELED = 'Cancelado',
    INACTIVE = 'Inativo',
}

/**
 * Mapeia cada valor do enum para o texto exibido no frontend.
 * Ex.: "ACTIVE" -> "Ativo"
 */
export const TypeSubscriptionStatusLabel: Record<TypeSubscriptionStatus, string> = {
    [TypeSubscriptionStatus.PENDING]: 'Pendente',
    [TypeSubscriptionStatus.ACTIVE]: 'Ativo',
    [TypeSubscriptionStatus.CANCELED]: 'Cancelado',
    [TypeSubscriptionStatus.INACTIVE]: 'Inativo',
};

/**
 * Mapeia cada valor do enum para uma cor padrão para exibição em badges no frontend.
 */
export const TypeSubscriptionStatusColor: Record<TypeSubscriptionStatus, string> = {
    [TypeSubscriptionStatus.PENDING]: '#FFA500',   // laranja
    [TypeSubscriptionStatus.ACTIVE]: '#228B22',    // verde escuro
    [TypeSubscriptionStatus.CANCELED]: '#B22222',  // vermelho escuro
    [TypeSubscriptionStatus.INACTIVE]: '#808080',  // cinza
};
